/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { ApiResponse } from 'shared/interfaces/site';

export const getProducers = (
	params?: any
): Promise<ApiResponse> => {
	return apiClient.get('/producers', {
		params: {
			pageSize: 100,
			query: params.queryParams,
			populate: '',
			sort: 'name',
		},
	});
};

export const getProducersHasAdditionalitiesProjects =
	(): Promise<any> => {
		return apiClient.get(
			'/additionalities/parent/producers'
		);
	};

const getProducersHasMeasurabilityProjects = (
	producers: any,
	producersIds: any
) => {
	if (
		producers &&
		producers.rows &&
		Array.isArray(producers.rows) &&
		producersIds &&
		producersIds.ids &&
		Array.isArray(producersIds.ids)
	) {
		const intersection = producers.rows.filter(
			(obj: any) => producersIds.ids.includes(obj.id)
		);

		return intersection;
	}
};

export const useProducersHasAdditionalities = (
	queryParams?: any
) => {
	const { data: producersIds } = useQuery({
		queryKey: ['producersIds-has-additionalities'],
		queryFn: getProducersHasAdditionalitiesProjects,
	});

	const { data, isFetching, isFetched } = useQuery({
		queryKey: [
			'producers-has-additionalities',
			{ queryParams: queryParams },
		],
		queryFn: () =>
			getProducers({ queryParams: queryParams }),
	});

	return {
		data: data
			? getProducersHasMeasurabilityProjects(
					data,
					producersIds
				)
			: [],
		allProducers: data && data.rows ? data.rows : [],
		isLoading: isFetching && !isFetched,
		isFetched,
		total: data?.total,
		page: data?.page,
		pageSize: data?.pageSize,
		totalPages: data?.totalPages,
	};
};
